import Relay from 'react-relay';

export default {
  sportStatusList: () => Relay.QL`query{ __type(name:"status") }`,
  viewer: (Component) => Relay.QL`query { viewer { ${Component.getFragment('viewer')} } }`,
};


// WEBPACK FOOTER //
// ./src/queries/SportListQueries.js